import React from "react";
import styles from "./Kpi.module.scss"
import ProgressBar from '../../ProgressBar'

function Kpi({ caption = '',  pct = 0 , indicatorPosition = 50}) {
    const randomProgress = getRandom(0,100)
    return <>
        <div className={styles.container} >
            <div className={styles.caption}>{caption}</div>
            <ProgressBar pct={pct} mark={indicatorPosition} />
        </div>
    </>
}
function getRandom(min=0, max =0) {
    return Math.floor(Math.random() * (+max - +min)) + +min;
}
export default Kpi;
